module.exports = __webpack_public_path__ + "img/bgr-stars.af74e3b2.svg";